
function initMetaobjectModal() {
  const images = document.querySelectorAll('.metaobject-image img');
  if (!images.length) return;

  images.forEach((img) => {
    if (img.dataset.modalInit) return;
    img.dataset.modalInit = 'true';

    img.addEventListener('click', (e) => {
      e.stopPropagation();

      if (document.querySelector('.metaobject-modal-overlay')) return;

      const modal = document.createElement('div');
      modal.className = 'metaobject-modal-overlay';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');

      const container = document.createElement('div');
      container.className = 'metaobject-modal-container';

      const closeBtn = document.createElement('button');
      closeBtn.className = 'metaobject-modal-close';
      closeBtn.setAttribute('type', 'button');
      closeBtn.setAttribute('aria-label', 'Stäng');
      closeBtn.innerHTML = '&times;';

      const loader = document.createElement('div');
      loader.className = 'metaobject-modal-loader';

      const image = document.createElement('img');
      image.className = 'metaobject-modal-image';
      image.alt = img.alt || '';

      image.src = img.src
        .replace(/width=\d+/i, 'width=1600')
        .replace(/&width=\d+/i, '&width=1600');

      let isClosing = false;

      // Swipe state
      let startY = 0;
      let currentY = 0;
      let isDragging = false;

      function unlockScroll() {
        document.documentElement.classList.remove('metaobject-modal-open');
        document.body.classList.remove('metaobject-modal-open');
      }

      function closeModal() {
        if (isClosing) return;
        isClosing = true;

        modal.classList.add('is-closing');
        modal.classList.remove('is-open');

        modal.addEventListener(
          'transitionend',
          () => {
            modal.remove();
            unlockScroll();
          },
          { once: true }
        );

        document.removeEventListener('keydown', escHandler);
      }

      function escHandler(e) {
        if (e.key === 'Escape') closeModal();
      }

      function openModal() {
        loader.remove();

        document.documentElement.classList.add('metaobject-modal-open');
        document.body.classList.add('metaobject-modal-open');

        modal.classList.add('is-ready');

        requestAnimationFrame(() => {
          modal.classList.add('is-open');
        });

        document.addEventListener('keydown', escHandler);
      }

      function resetDrag() {
        container.style.transform = '';
        modal.style.opacity = '';
        container.classList.remove('is-dragging');
      }

      function onTouchStart(e) {
        if (window.innerWidth > 749) return;
        if (!e.touches || e.touches.length !== 1) return;

        startY = e.touches[0].clientY;
        currentY = startY;
        isDragging = true;
        container.classList.add('is-dragging');
      }

      function onTouchMove(e) {
        if (!isDragging) return;
        if (!e.touches || e.touches.length !== 1) return;

        currentY = e.touches[0].clientY;
        const deltaY = currentY - startY;

        // Bara dra nedåt
        if (deltaY < 0) return;

        const moveY = deltaY;
        const scale = Math.max(0.94, 1 - deltaY / 1200);
        const overlayOpacity = Math.max(0.3, 1 - deltaY / 500);

        container.style.transform = `translateY(${moveY}px) scale(${scale})`;
        modal.style.opacity = overlayOpacity;
      }

      function onTouchEnd() {
        if (!isDragging) return;
        isDragging = false;

        const deltaY = currentY - startY;
        container.classList.remove('is-dragging');

        if (deltaY > 120) {
          closeModal();
        } else {
          resetDrag();
        }
      }

      closeBtn.addEventListener('click', closeModal);

      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });

      container.addEventListener('click', (e) => e.stopPropagation());

      // Swipe down to close
      container.addEventListener('touchstart', onTouchStart, { passive: true });
      container.addEventListener('touchmove', onTouchMove, { passive: true });
      container.addEventListener('touchend', onTouchEnd);
      container.addEventListener('touchcancel', onTouchEnd);

      container.appendChild(closeBtn);
      container.appendChild(loader);
      container.appendChild(image);
      modal.appendChild(container);
      document.body.appendChild(modal);

      if (image.complete && image.naturalWidth > 0) {
        openModal();
      } else {
        image.addEventListener('load', openModal, { once: true });

        image.addEventListener(
          'error',
          () => {
            loader.remove();
            document.documentElement.classList.add('metaobject-modal-open');
            document.body.classList.add('metaobject-modal-open');
            modal.classList.add('is-ready', 'is-open');
            document.addEventListener('keydown', escHandler);
          },
          { once: true }
        );
      }
    });
  });
}

/* Init hooks */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMetaobjectModal);
} else {
  initMetaobjectModal();
}

setTimeout(initMetaobjectModal, 500);

if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', initMetaobjectModal);
}
